/**
 * @desc 添加订单备注
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.SystemOrderRemarkRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderRemark/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
